<template>
  <div id="Map">
    <div class="left">
      <transition name="slide-fade">
        <MapSvg
          id="Map1"
          v-if="activeMap == 'full'"
          :activeSection="activeSection"
          @changeSection="changeSection"
        />
      </transition>
      <transition name="slide-fade">
        <Courtside2
          id="Map2"
          v-if="activeMap == 'courtside'"
          :activeSection="activeSection"
          @changeSection="changeSection"
        />
      </transition>
    </div>
    <div class="right">
      <SelectSeat
        :activeSection="activeSection"
        :activeMap="activeMap"
        @changeSection="changeSection"
        @changeMap="changeMap"
      />
    </div>
  </div>
</template>

<script>
import MapSvg from "./MapSvg";
import SelectSeat from "./SelectSeat";
import Courtside2 from "./Courtside2";
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "Map",
  components: {
    MapSvg,
    SelectSeat,
    Courtside2,
  },
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
    });

    return { ...toRefs(state) };
  },
  data() {
    return {
      activeSection: "super vip's row 1",
      activeMap: "full",
    };
  },
  watch: {
    purl(to, from) {
      if (to.accounts) {
        this.setSection(to.accounts[0].mapPreFilter.toLowerCase());
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.purl.accounts) {
        this.setSection(this.purl.accounts[0].mapPreFilter.toLowerCase());
      }
    }, 1000);
  },
  methods: {
    changeSection(section) {
      this.activeSection = section;
      // console.log("emit", this.activeSection);
    },
    changeMap(map) {
      this.activeMap = map;
    },
    setSection(section) {
      // console.log("section", section);
      switch (section) {
        case "super vip's row 1":
          this.activeSection = "super vip's row 1";
          break;
        case "super vip's row 2":
          this.activeSection = "super vip's row 2";
          break;
        case "row 1 center court":
          this.activeSection = "row 1 center court";
          break;
        case "row 1 sideline":
          this.activeSection = "row 1 sideline";
          break;
        case "row 1 baseline":
          this.activeSection = "row 1 baseline";
          break;
        case "row 2 center":
          this.activeSection = "row 2 center";
          break;
        case "row 2 sideline":
          this.activeSection = "row 2 sideline";
          break;
        case "row 2 baseline":
          this.activeSection = "row 2 baseline";
          break;
        case "row 3 center":
          this.activeSection = "row 3 center";
          break;
        case "row 3 sideline":
          this.activeSection = "row 3 sideline";
          break;
        case "row 3 baseline":
          this.activeSection = "row 3 baseline";
          break;
        case "players club rows 1-4":
          this.activeSection = "players club rows 1-4";
          break;
        case "lower center court (rehmann) rows 5-9":
          this.activeSection = "lower center court (rehmann) rows 5-9";
          break;
        case "lower center court (rehmann) rows 10+":
          this.activeSection = "lower center court (rehmann) rows 10+";
          break;
        case "lower center sideline (rehmann) rows 5-9":
          this.activeSection = "lower center sideline (rehmann) rows 5-9";
          break;
        case "lower center sideline (rehmann) rows 10+":
          this.activeSection = "lower center sideline (rehmann) rows 10+";
          break;
        case "lower center court (mcc) rows 1-4":
          this.activeSection = "lower center court (mcc) rows 1-4";
          break;
        case "lower center court (mcc) rows 5-9":
          this.activeSection = "lower center court (mcc) rows 5-9";
          break;
        case "lower center court (mcc) rows 10+":
          this.activeSection = "lower center court (mcc) rows 10+";
          break;
        case "lower center sideline (mcc) rows 1-4":
          this.activeSection = "lower center sideline (mcc) rows 1-4";
          break;
        case "lower center sideline (mcc) rows 5-9":
          this.activeSection = "lower center sideline (mcc) rows 5-9";
          break;
        case "lower center sideline (mcc) rows 10+":
          this.activeSection = "lower center sideline (mcc) rows 10+";
          break;
        case "legends club":
          this.activeSection = "legends club";
          break;
        case "lower center sideline (100l) rows 1-4":
          this.activeSection = "lower center sideline (100L) rows 1-4";
          break;
        case "lower center sideline (100l) rows 5-9":
          this.activeSection = "lower center sideline (100L) rows 5-9";
          break;
        case "lower center sideline (100l) rows 10+":
          this.activeSection = "lower center sideline (100L) rows 10+";
          break;
        case "lower semi corner/bookends rows 1-4":
          this.activeSection = "lower semi corner/bookends rows 1-4";
          break;
        case "lower semi corner/bookends rows 5-9":
          this.activeSection = "lower semi corner/bookends rows 5-9";
          break;
        case "lower semi corner/bookends rows 10+":
          this.activeSection = "lower semi corner/bookends rows 10+";
          break;
        case "lower corner rows 1-4":
          this.activeSection = "lower corner rows 1-4";
          break;
        case "lower corner rows 5-9":
          this.activeSection = "lower corner rows 5-9";
          break;
        case "lower corner rows 10+":
          this.activeSection = "lower corner rows 10+";
          break;
        case "lower ends rows 1-4":
          this.activeSection = "lower ends rows 1-4";
          break;
        case "lower ends rows 5-9":
          this.activeSection = "lower ends rows 5-9";
          break;
        case "lower ends rows 10+":
          this.activeSection = "lower ends rows 10+";
          break;
        case "mezzanine level center":
          this.activeSection = "mezzanine level center";
          break;
        case "mezzanine level corner":
          this.activeSection = "mezzanine level corner";
          break;
        case "mezzanine level end":
          this.activeSection = "mezzanine level ends";
          break;
        default:
          this.activeSection = "super vip's row 1";
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#Map {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 94.46px;
  height: fit-content;
  @media (max-width: 992px) {
    flex-direction: column;
    margin-bottom: 45px;
  }
  .left {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(50% - 19.5px);
    height: 492px;
    @media (max-width: 1400px) {
      height: 422px;
    }
    @media (max-width: 1200px) {
      height: 351px;
    }
    @media (max-width: 992px) {
      width: 100%;
      height: 544.344px;
    }
    @media (max-width: 767px) {
      height: 403.562px;
    }
    @media (max-width: 575px) {
      height: 74.929vw;
    }
    #Map1,
    #Map2 {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
  .right {
    height: 100%;
    width: calc(50% - 19.5px);
    @media (max-width: 992px) {
      margin-top: 32px;
      width: 100%;
    }
  }
  .slide-fade-enter-active {
    transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1),
      transform 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter-from {
    opacity: 0;
    transform: translate(-10px);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
}
</style>